import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import authService from "@/authService";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/loginView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = await authService.checkTokenValidity();

  if (to.path !== "/login" && !isAuthenticated) {
    return next("/login"); // Wenn nicht eingeloggt, zum Login weiterleiten
  }

  if (to.path === "/login" && isAuthenticated) {
    return next("/"); // Wenn bereits eingeloggt, zur Startseite weiterleiten
  }

  next(); // Weiter zur nächsten Route
});

router.onError((error) => {
  if (
    error.response &&
    (error.response.status === 401 || error.response.status === 401)
  ) {
    authService.checkTokenValidity().then((isValid) => {
      if (!isValid) {
        authService.clearAuthToken();
        router.push("/login");
      }
    });
  }
});

export default router;
